export default __webpack_public_path__ + "static/media/single-project-page-01-img17.8732cc8e.png";